import styled from '@emotion/styled';
import { Icon } from '@innovamat/glimmer-components';

type OrderReturnTagProps = {
  isOrder: boolean;
  tag: string;
};

const Wrapper = styled.div<{ isOrder: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: ${({ isOrder, theme }) =>
    isOrder
      ? theme.tokens.color.alias.cm.bg['bg-info'].value
      : theme.tokens.color.alias.cm.bg['bg-warning'].value};
  color: ${({ isOrder, theme }) =>
    isOrder
      ? theme.tokens.color.alias.cm.text['text-info'].value
      : theme.tokens.color.alias.cm.text['text-warning'].value};
`;

const ArrowIcon = styled(Icon)`
  width: 1rem;
  height: 1rem;
`;

function OrderReturnTag({ isOrder, tag }: OrderReturnTagProps): JSX.Element {
  return (
    <Wrapper isOrder={isOrder}>
      <span>{tag}</span>
      <ArrowIcon
        icon={isOrder ? 'NextWithTextIcon' : 'PreviousWithTextIcon'}
        size="S"
      />
    </Wrapper>
  );
}

export { OrderReturnTag };
